module.exports = __webpack_public_path__ + "increase.png?87f8021129258bda5305c18b9c899e9b";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/increase.png
// module id = 343
// module chunks = 0